"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EValidationError = void 0;
exports.EValidationError = {
    anchorNotExists: "anchorNotExists",
    arrayNotEmpty: "arrayNotEmpty",
    badContributors: "badContributors",
    badCredentials: "badCredentials",
    buttonLabelIsRequired: "buttonLabelIsRequired",
    buttonLinkIsRequired: "buttonLinkIsRequired",
    choiceNotExists: "choiceNotExists",
    emailCaseSensitive: "emailCaseSensitive",
    emailNotExists: "emailNotExists",
    emailNotFound: "emailNotFound",
    fileNotExists: "fileNotExists",
    firstNameIsRequired: "firstNameIsRequired",
    invalidLinkedInUrl: "invalidLinkedInUrl",
    invalidPhoneNumber: "invalidPhoneNumber",
    isArray: "isArray",
    isBoolean: "isBoolean",
    isDate: "isDate",
    isEmail: "isEmail",
    isEnum: "isEnum",
    isInt: "isInt",
    isNotEmpty: "isNotEmpty",
    isNumber: "isNumber",
    isNumberString: "isNumberString",
    isObject: "isObject",
    isPositive: "isPositive",
    isString: "isString",
    isStrongPassword: "isStrongPassword",
    isUrl: "isUrl",
    lastNameIsRequired: "lastNameIsRequired",
    match: "match",
    maxLength: "maxLength",
    max: "max",
    mediaUrlIsRequired: "mediaUrlIsRequired",
    minLength: "minLength",
    min: "min",
    mustBeInThePast: "mustBeInThePast",
    passwordNotMatch: "passwordNotMatch",
    pinCodeNotValid: "pinCodeNotValid",
    projectTeamNotExist: "projectTeamNotExist",
    subscriptionPlanNotExists: "subscriptionPlanNotExists",
    uniqueEmail: "uniqueEmail",
    uniqueSha256: "uniqueSha256",
    wrongDateInterval: "wrongDateInterval",
    wrongPassword: "wrongPassword",
    isDefined: "isDefined",
};
